// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header_box":"header_box-1jgoql7F","header":"header-3BTTJOcI clearfix"};